import styled from 'styled-components';

export const ConfigContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 0px 0px 15px;
  max-width: 500px;

  label {
    cursor: pointer;
    padding: 0 16px;
    color: ${({ theme }) => theme.colors.grey6};
  }
`;

export const ConfigItem = styled.div`
  margin: 0px 0px 0px 25px;

  h4 {
    margin: 0px;
    color: ${({ theme }) => theme.colors.grey6};
  }
`;